var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stageImage)?_c('div',{staticClass:"owc-stage-image"},[_c('GenericImage',{staticClass:"owc-stage-image__image-tag",attrs:{"imageData":_vm.stageImage,"loadEager":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }